/* eslint-disable no-bitwise */
import i18n from 'i18next';
import {IElementQuestionAnswer} from '../incase-domain/elements/base/questionElementBase';

export function hash(object: Record<string, unknown>, length: number): number {
    let hash = 0;
    for (let i = 0; i < length; i++) {
        const character = JSON.stringify(object).charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash &= hash;
    }

    return hash;
}

export function answersCreator(answerNum?: number): IElementQuestionAnswer[] {
    if (!answerNum) {
        return [];
    }

    const answers = [];

    for (let i = 0; i < answerNum; i++) {
        answers.push({
            text: `${i18n.t('presEditPage.editSidebar.elements.initialStates.answer')} ${i + 1}`,
            type: 'incorrect',
            comment: '',
        } as IElementQuestionAnswer);
    }

    return answers;
}

export function createYesNoAnswers(): IElementQuestionAnswer[] {
    return [
        {text: 'Yes', type: 'correct', comment: ''},
        {text: 'No', type: 'incorrect', comment: ''},
    ];
}
